import { gql } from "@apollo/client";

export const GET_RACES_MTP_STATUS = gql`
  query getRacesMtpStatus(
    $wagerProfile: String
    $sortBy: RaceListSort
    $filterBy: RaceListFilter
  ) {
    raceDate
    mtpRaces: races(filter: $filterBy, profile: $wagerProfile, sort: $sortBy) {
      trackCode
      trackName
      number
      mtp
      postTime
      status {
        code
      }
    }
  }
`;

export default GET_RACES_MTP_STATUS;
